import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface SidebarContextType {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType | null>(null);

interface SidebarProviderProps {
  children: ReactNode;
}

const SIDEBAR_STORAGE_KEY = 'sidebar_expanded';

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  // Initialize from localStorage, default to false if not set
  const [expanded, setExpandedState] = useState<boolean>(() => {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return stored ? JSON.parse(stored) : false;
  });

  // Update localStorage whenever expanded state changes
  useEffect(() => {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(expanded));
  }, [expanded]);

  const setExpanded = (value: boolean) => {
    setExpandedState(value);
  };

  return (
    <SidebarContext.Provider value={{ expanded, setExpanded }}>{children}</SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
